import {
  API_REQUEST,
  GET_CURRENT_CONTRACT,
  GET_PACKAGE_PRICES,
  CREATE_SUBSCRIPTION_REQUEST,
  CONTACT_ME_REQUEST,
  LAST_SUBSCRIPTION_REQUEST,
  FETCH_PAYMENT_STATUS,
  FETCH_COMPANY_TYPES,
  CREATE_CUSTOMER_AND_SETUP_INTENT,
  ATTACH_PAYMENT_METHOD,
  MAKE_PAYMENT,
  RESET_ERROR
} from 'constants/action-types';
import { HUBSPOT_PORTAL_ID, HUBSPOT_FORM_GUID } from 'constants/urls';
import type { HubSpotForm, SubscriptionRequestRequest } from 'types/join';

export function fetchCompanyTypes() {
  return {
    type: API_REQUEST,
    payload: {
      url: '/CompanyTypes',
      method: 'get',
      nextActionType: FETCH_COMPANY_TYPES
    }
  };
}

export function ConfirmAndCheckout(subscriptionRequestObject: SubscriptionRequestRequest) {
  return {
    type: API_REQUEST,
    payload: {
      url: `/RapnetRegistration`,
      method: 'post',
      data: subscriptionRequestObject,
      nextActionType: CREATE_SUBSCRIPTION_REQUEST
    },
    noAuth: true,
    meta: {
      hasLoader: true
    }
  };
}

export function createHubSpotForm(hubSpotForm: HubSpotForm) {
  return {
    type: API_REQUEST,
    payload: {
      url: `https://api.hsforms.com/submissions/v3/integration/submit/${HUBSPOT_PORTAL_ID}/${HUBSPOT_FORM_GUID}`,
      method: 'post',
      data: hubSpotForm
    },
    noAuth: true,
    meta: { external: true }
  };
}

export function getRegistrationCurrentContract(email: string, recaptcha: string) {
  return {
    type: API_REQUEST,
    payload: {
      url: `/CurrentContract`,
      method: 'post',
      data: { email, recaptcha },
      nextActionType: GET_CURRENT_CONTRACT
    },
    noAuth: true,
    meta: {
      hasLoader: true
    }
  };
}
export function LastSubscriptionRequest(email: string, recaptcha: string) {
  return {
    type: API_REQUEST,
    payload: {
      url: `/LastSubscriptionRequest`,
      method: 'post',
      data: { email, recaptcha },
      nextActionType: LAST_SUBSCRIPTION_REQUEST
    },
    noAuth: true
  };
}

export function ContactMeRequest(opportunityId: any, email: string, recaptcha: string) {
  return {
    type: API_REQUEST,
    payload: {
      url: `/Opportunity/${opportunityId}/AddPaymentRequest`,
      method: 'post',
      data: { email, recaptcha },
      nextActionType: CONTACT_ME_REQUEST
    },
    noAuth: true
  };
}

export function getPackagePrices() {
  return {
    type: API_REQUEST,
    payload: {
      url: `/PackagePrices`,
      method: 'get',
      nextActionType: GET_PACKAGE_PRICES
    },
    noAuth: true,
    meta: {}
  };
}

export function fetchPaymentStatus(opportunityId: any, email: string, recaptcha: string) {
  return {
    type: API_REQUEST,
    payload: {
      url: `/Opportunity/${opportunityId}/PaymentStatus`,
      method: 'post',
      data: { email, recaptcha },
      nextActionType: FETCH_PAYMENT_STATUS
    },
    noAuth: true
  };
}

export function resetError() {
  return {
    type: RESET_ERROR
  };
}

// Payment actions:

export function createCustomerAndSetupIntent(email: string, packageName: string) {
  return {
    type: API_REQUEST,
    payload: {
      url: `/CustomerAndIntent`,
      method: 'post',
      data: { email, packageName },
      nextActionType: CREATE_CUSTOMER_AND_SETUP_INTENT
    },
    noAuth: true
  };
}

export function attachPaymentMethod(email: string, paymentMethodId: string, customerId: string) {
  return {
    type: API_REQUEST,
    payload: {
      url: `/PaymentMethod/Attach`,
      method: 'post',
      data: { email, paymentMethodId, customerId },
      nextActionType: ATTACH_PAYMENT_METHOD
    },
    noAuth: true
  };
}

export function makePayment(email: string, paymentMethodId: string, customerId: string) {
  return {
    type: API_REQUEST,
    payload: {
      url: `/Payment/RapWebPayment`,
      method: 'post',
      data: { email, paymentMethodId, customerId },
      nextActionType: MAKE_PAYMENT
    },
    noAuth: true
  };
}
